import Icon, { IconName } from './Icon'

export default function Footer() {
	return (
		<footer className='text-center py-12 text-zinc-600 font-ubuntu text-sm'>This website is fully designed and created by myself.</footer>
	)
}
